import { useEffect, useState } from 'react';

/** Верхняя граница мобильного диапазона (включительно) */
export const BP_MOBILE_MAX = 744;
/** Верхняя граница планшета (включительно); десктоп с 1401px */
export const BP_TABLET_MAX = 1400;

function getBreakpoint(width) {
  if (width <= BP_MOBILE_MAX) return 'mobile';
  if (width <= BP_TABLET_MAX) return 'tablet';
  return 'desktop';
}

/**
 * @returns {'mobile' | 'tablet' | 'desktop'}
 */
export function useViewportBreakpoint() {
  const [bp, setBp] = useState(() => getBreakpoint(typeof window !== 'undefined' ? window.innerWidth : BP_TABLET_MAX));

  useEffect(() => {
    const onResize = () => setBp(getBreakpoint(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return bp;
}
